import { render, staticRenderFns } from "./ReportTemplate.vue?vue&type=template&id=54687e7d&scoped=true"
import script from "./ReportTemplate.vue?vue&type=script&lang=js"
export * from "./ReportTemplate.vue?vue&type=script&lang=js"
import style0 from "./ReportTemplate.vue?vue&type=style&index=0&id=54687e7d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54687e7d",
  null
  
)

export default component.exports